module.exports = __webpack_public_path__ + "static/media/ts-logo.701ad2dd.webp";